<template>
  <div class="preika-auth-page">
    <section class="preika-error-panel">
      <img
        src="/img/avatars/preika_black.png"
        :alt="productName"
        class="preika-error-panel__logo"
      >
      <span class="preika-error-panel__icon">
        <CIcon name="cil-x-circle"/>
      </span>
      <h1>処理を完了できませんでした</h1>
      <!--
        **この画面はログインが生きているときにしか出ない**（束23）。

        ここへ来るのは、画面を開くときの番号の引き当てが、401・403・400
        以外（サーバの不調や通信断）で失敗したときだけ。401 ならログイン画面へ
        直行し、この画面もルータの前段でログインを確かめてから出る。
        以前は「ログインの有効期限が切れている可能性」と言い、［ログイン画面へ］
        しか無かった。入り直しても直らない。
      -->
      <p>
        ページへのアクセス中にエラーが発生しました。少し時間をおいて［もう一度開く］を押すか、［ダッシュボードへ］移動してください。
      </p>
      <div class="preika-error-panel__actions">
        <button
          type="button"
          class="btn btn-primary"
          :disabled="!reopenPath"
          @click="reopen"
        >
          もう一度開く
        </button>
        <router-link to="/dashboard" class="btn btn-outline-primary">
          ダッシュボードへ
          <CIcon name="cil-arrow-right"/>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { PRODUCT_NAME } from '@/common/productName'

export default {
  name: 'UserError',

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    },

    /**
     * 開き直す先（ここへ送ったルータが渡す、元の画面の道）。
     *
     * **この製品の中の道だけ。**「/」で始まり「//」で始まらないもの
     * （外の場所を指す形を通さない）。この画面自身も除く。そうでなければ
     * 空で、［もう一度開く］は押せない。
     */
    reopenPath () {
      const query = (this.$route && this.$route.query) || {}
      const from = typeof query.from === 'string' ? query.from : ''
      if (!from.startsWith('/') || from.startsWith('//')) return ''
      if (from.indexOf('\\') >= 0) return ''
      if (from.startsWith('/pages/user_error')) return ''
      return from
    }
  },

  methods: {
    reopen () {
      if (!this.reopenPath || !this.$router) return
      this.$router.replace(this.reopenPath).catch(() => {})
    }
  }
}
</script>

<style scoped>
.preika-error-panel {
  position: relative;
  z-index: 1;
  width: min(100%, 620px);
  padding: 52px;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 25px;
  background: rgba(255, 255, 255, .95);
  box-shadow: 0 30px 80px rgba(7, 52, 87, .17);
  text-align: center;
}

.preika-error-panel__logo {
  width: 150px;
  max-height: 48px;
  margin-bottom: 25px;
  object-fit: contain;
}

.preika-error-panel__icon {
  display: inline-flex;
  width: 70px;
  height: 70px;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 23px;
  background: var(--preika-danger-100);
  color: var(--preika-danger-600);
  font-size: 34px;
}

.preika-error-panel h1 {
  margin: 14px 0 12px;
  color: var(--preika-navy-900);
  font-size: 24px;
}

.preika-error-panel p {
  max-width: 470px;
  margin: 0 auto;
  color: var(--preika-text-muted);
  font-size: 12px;
  line-height: 1.9;
}

.preika-error-panel__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-top: 28px;
}

@media (max-width: 575.98px) {
  .preika-error-panel {
    padding: 38px 23px;
  }
}
</style>
